import styles from "./styles.module.scss";
import Section from "../../../components/Section";

import figma_icon from "../../../graphics/figma_icon.svg";

import building_1 from "../../../images/building_1.png";
import building_2 from "../../../images/building_2.png";
import building_3 from "../../../images/building_3.png";
import building_4 from "../../../images/building_4.png";
import building_5 from "../../../images/building_5.png";
import building_6 from "../../../images/building_6.png";

const Buildings = () => {
  return (
    <Section>
      <div className={styles.container}>
        <h2 className={styles.title}>Сайт жилого комплекса</h2>
        <div className={styles.content}>
          <div className={styles.item}>
            <h4 className={styles.subtitle}>Бизнес-задача</h4>
            <p className={styles.text}>
              Разработать современный сайт, способный демонстрировать
              преимущества жилого комплекса, доступные варианты планировок и
              различные способы покупки, делая акцент на прозрачности и
              удобстве.
            </p>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Процесс решения</h4>
            <p className={styles.text}>
              Применила минималистичный и понятный интерфейс, чтобы важная
              информация была легко доступна. Продумала функционал для удобного
              просмотра квартир и возможностей покупки, что помогает быстро
              ориентироваться в предложениях.
            </p>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Color palette</h4>
            <div className={styles.palette_container}>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#1D1D1D" }}
              >
                <p>
                  Black <br /> #1D1D1D
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#181D23" }}
              >
                <p>
                  Dark-blue <br /> #181D23
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#856756" }}
              >
                <p>
                  Brown <br /> #856756
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#868686" }}
              >
                <p>
                  Light-gray <br /> #868686
                </p>
              </div>
              <div
                className={styles.palette}
                style={{ backgroundColor: "#FFFFFF" }}
              >
                <p>
                  White <br /> #FFFFFF
                </p>
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Fonts</h4>
            <div className={styles.fonts_container}>
              <div className={styles.font}>
                <div className={styles.iowan}>
                  <p className={styles.colored}>Aa</p>
                  <p>Iowan Old Style</p>
                </div>
              </div>
              <div className={styles.font}>
                <div className={styles.helvetica}>
                  <p className={styles.colored}>Aa</p>
                  <p>Helvetica</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Layout Grid</h4>
            <div className={styles.layout_container}>
              <p>12 columns</p>
              <p>150 margin</p>
              <p>32 gutter</p>
            </div>
          </div>
        </div>

        <div className={styles.images}>
          <div className={styles.row}>
            <div className={styles.item}>
              <img src={building_1} alt="" />
            </div>
            <div className={styles.item}>
              <img src={building_2} alt="" />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.item}>
              <img src={building_3} alt="" />
            </div>
            <div className={styles.item}>
              <img src={building_4} alt="" />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.item}>
              <img src={building_5} alt="" />
            </div>
            <div className={styles.item}>
              <img src={building_6} alt="" />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Buildings;
